import {
  GET_ADMIN_USER_DATA_REQUEST,
  GET_ADMIN_USER_DATA_SUCCESS,
  GET_ADMIN_USER_DATA_FAILURE,
} from './Dashboard.constant';
import { HierarchyData } from './Dashboard.type';

export const getAdminUserDataRequest = (payload: number | string) => ({
  type: GET_ADMIN_USER_DATA_REQUEST,
  payload,
});

export const getAdminUserDataSuccess = (payload: HierarchyData) => ({
  type: GET_ADMIN_USER_DATA_SUCCESS,
  payload,
});

export const getAdminUserDataFailure = (payload: unknown) => ({
  type: GET_ADMIN_USER_DATA_FAILURE,
  payload,
});
